import { PageItemApi } from 'api/PageItemApi';
import { PageItemKindMapper } from 'mapper/PageItemMapper';
import { QuestionAbstractMapper } from 'mapper/QuestionAbstractMapper';
import { PageItemModel } from 'api/dto/PageItem.dto';
import { PageItemKind } from 'model/PageItemKind';
import { QuestionCAS } from 'model/QuestionCAS';

export class QuestionCASMapper
  implements PageItemKindMapper<QuestionCAS, PageItemApi.QuestionCASEntry>
{
  serialize(model: QuestionCAS): PageItemApi.QuestionCASEntry {
    return {
      ...QuestionAbstractMapper.serialize(model),
      required: model.isRequired ? 1 : 0,
    };
  }

  deserialize(entry: PageItemApi.QuestionCASEntry): QuestionCAS {
    return {
      ...QuestionAbstractMapper.deserializeShape(entry),
      isRequired: Boolean(entry.required),
    };
  }

  supportsSerialize(model: PageItemModel): boolean {
    return model.kind === PageItemKind.QuestionCAS;
  }

  supportsDeserialize(entry: PageItemApi.ItemEntry): boolean {
    return entry.kind === PageItemKind.QuestionCAS;
  }
}
